import { FormEvent, useEffect, useState } from 'react'
import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

// Libs
import useMedia from '@/hooks/useMedia'

// Methods
import { helpSearchPath } from '../../methods'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  defaultValue?: string
  countryQuery?: string
  /** 內頁麵包屑旁的小搜尋框 */
  compact?: boolean
}

const SearchBox = ({ defaultValue = '', countryQuery, compact }: Props) => {
  const { t } = useTranslation()
  const router = useRouter()
  const [keyword, setKeyword] = useState(defaultValue)
  const { isMobile } = useMedia()

  useEffect(() => setKeyword(defaultValue), [defaultValue])

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    const q = keyword.trim()
    if (!q) return
    router.push(helpSearchPath(q, countryQuery))
  }

  return (
    <form className={cx('help-search', { 'help-search--compact': compact })} role='search' onSubmit={handleSubmit}>
      <svg className={cx('help-search__icon')} viewBox='0 0 24 24' width={compact ? 18 : 22} height={compact ? 18 : 22} aria-hidden>
        <circle cx='11' cy='11' r='7' fill='none' stroke='currentColor' strokeWidth='2' />
        <path d='M20 20l-3.5-3.5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
      </svg>
      <input
        className={cx('help-search__input')}
        type='search'
        value={keyword}
        maxLength={100}
        // 範例關鍵字由下方「熱門搜尋」呈現；長版提示在手機會被截斷，桌機才用
        placeholder={t(compact || isMobile ? 'Help_Center_Search_Placeholder_Short' : 'Help_Center_Search_Placeholder')}
        aria-label={t('Help_Center_Search_Placeholder_Short')}
        onChange={(e) => setKeyword(e.target.value)}
      />
      {!compact && (
        <button className={cx('help-search__button')} type='submit'>
          {t('Help_Center_Search_Button')}
        </button>
      )}
    </form>
  )
}

export default SearchBox
